import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.colors.white,
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  paper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    padding: [theme.spacing(2), theme.spacing(2), 0],
    [theme.breakpoints.up('mobile')]: {
      minWidth: 800,
      maxWidth: 1280,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/useStyles.js